<template>
    <div class="w-100 h-100">
        <b-container fluid>
            <h2 class="tw-mb-0 text-aegis-dk">General Team Documents</h2>
            <p class="tw-italic tw-text-gray-700">Upload any type of file.</p>
        </b-container>

        <hr />

        <b-container>
            <b-row>
                <b-col md="6" offset-md="3" class="mt-3">
                    <b-form-file
                        id="file"
                        v-model="selectedFile"
                        :state="Boolean(selectedFile)"
                        placeholder="Choose a file or drop it here..."
                        drop-placeholder="Drop file here..."
                        size="lg"
                    ></b-form-file>
                </b-col>
            </b-row>
            <b-row>
                <b-col md="6" offset-md="3" class="mt-3">
                    <b-form-input
                        v-model="title"
                        placeholder="Enter Document Title"
                        size="lg"
                    ></b-form-input>
                </b-col>
            </b-row>
            <b-row>
                <b-col md="6" offset-md="3" class="mt-3">
                    <b-form-checkbox
                        id="is-private"
                        v-model="isPrivate"
                        name="is-private"
                        value="1"
                        unchecked-value=""
                        size="lg"
                    >
                        Only I can view this document! (Not Public)
                    </b-form-checkbox>
                </b-col>
            </b-row>
            <b-row>
                <b-col md="6" offset-md="3" class="mt-3">
                    <b-button
                        @click="onUpload()"
                        variant="success"
                        size="lg"
                        block
                        :disabled="uploading"
                    >
                        Upload
                    </b-button>
                </b-col>
            </b-row>
        </b-container>

        <hr />

        <b-container fluid>
            <b-row>
                <b-col>
                    <b-form-input
                        v-model="search.title"
                        placeholder="Search Title"
                        size="lg"
                        @keyup="find()"
                    ></b-form-input>
                </b-col>
            </b-row>
        </b-container>

        <hr>

        <b-table
            striped
            borderless
            :fields="fields"
            :items="uploads"
            class="table-sm tw-text-sm"
        >
            <template v-slot:cell(user)="data">
                {{ data.value.name ? data.value.name : data.value.email }}
            </template>
            <template v-slot:cell(download)="data">
                <i
                    class="fas fa-download tw-cursor-pointer"
                    @click="download(data.item)"
                ></i>
            </template>
            <template v-slot:cell(delete)="data">
                <i
                    class="fas fa-trash tw-cursor-pointer"
                    @click="remove(data.item.id)"
                ></i>
            </template>
            <template v-slot:cell(is_private)="data">
                <i class="fas fa-check" v-if="!data.value"></i>
            </template>
        </b-table>
    </div>
</template>

<script>
import { HTTP } from "@/utilities/http-common";
import HandleErrors from "@/utilities/handle-errors";

import DashboardBaseTemplate from "@/layouts/DashboardBaseTemplate.vue";
import { mapGetters } from "vuex";

import * as _ from "lodash";

export default {
    mixins: [DashboardBaseTemplate],
    data() {
        return {
            baseUrl: `/srilanka/uploads/`,
            selectedFile: null,
            title: "",
            category: "Document",  // This page ONLY deals with the Document category
            isPrivate: "",
            fields: [
                "title",
                { key: "upload", label: "File" },
                { key: "is_private", label: "General" },
                // "category",
                "user",
                "download",
                "delete",
            ],
            uploads: [],
            uploading: false,
            // search: {},
            search: {
                category: "Document"  // set the inital value so that the drop-down will display "-- Select Category --"
            },
        };
    },
    computed: {
        ...mapGetters("user", ['inMyGroups']),
    },
    watch: {},
    created() {
        this.find();
    },
    mounted() {},
    methods: {
        find() {
            const that = this;
            HTTP.get(that.baseUrl, { params: { ...that.search } })
                .then((response) => {
                    that.uploads = response.data;
                })
                .catch((error) => {
                    HandleErrors.HandleErrors(error);
                });
        },
        download(item) {
            const that = this;
            const d = new Date();
            let time = d.getTime();

            let downloadUrl = `${that.baseUrl}${item.id}?rand=${time}`;
            HTTP.get(downloadUrl, { responseType: "arraybuffer" })
                .then((response) => {
                    var fileURL = window.URL.createObjectURL(
                        new Blob([response.data])
                    );
                    var fileLink = document.createElement("a");
                    fileLink.href = fileURL;
                    fileLink.setAttribute("download", item.upload);
                    document.body.appendChild(fileLink);
                    fileLink.click();
                })
                .catch((error) => {
                    HandleErrors.HandleErrors(error);
                });
        },
        remove(id) {
            const that = this;
            let deleteUrl = `${that.baseUrl}${id}`;
            HTTP.delete(deleteUrl)
                .then(() => {
                    that.uploads = _.filter(that.uploads, function (o) {
                        return o.id !== id;
                    });
                })
                .catch((error) => {
                    HandleErrors.HandleErrors(error);
                });
        },
        onFileSelected: function (event) {
            this.selectedFile = event.target.files[0];
        },
        onUpload: function () {
            const that = this;
            if (!that.selectedFile) {
                return that.$bvModal.msgBoxOk("Please select a file!", {
                    title: "File Error",
                    okVariant: "danger",
                    centered: true,
                });
            }

            if (!that.title.trim()) {
                return that.$bvModal.msgBoxOk("Please select a title!", {
                    title: "Title Error",
                    okVariant: "danger",
                    centered: true,
                });
            }

            if (!that.category.trim()) {
                return that.$bvModal.msgBoxOk("Please select a category!", {
                    title: "Category Error",
                    okVariant: "danger",
                    centered: true,
                });
            }

            that.uploading = true;

            const fd = new FormData();
            fd.append("file", that.selectedFile, that.selectedFile.name);
            fd.append("title", that.title);

            fd.append("is_private", that.isPrivate);  // selecting an SAE category no longer always sets to private

            fd.append("category", that.category);

            HTTP.post(that.baseUrl, fd)
                .then(() => {
                    that.selectedFile = null;
                    that.$notify({
                        text: "File successfully uploaded!",
                        duration: 10000,
                        type: "success",
                    });

                    that.selectedFile = null;
                    that.title = "";
                    that.category = "";
                    that.isPrivate = false;
                    that.sae_case = null;
                    that.sae_selected = false;

                    that.find();
                })
                .catch((error) => {
                    HandleErrors.HandleErrors(error);
                })
                .then(() => {
                    that.uploading = false;
                });
        },
    },
};
</script>
